export enum ParcelCancellationStatus {
    Confirmed = "Confirmed",
    NotConfirmed = "NotConfirmed",
}
